/**
 * These are the available translatable objects which will be referenced by the
 * SDK internally when templating the UI.
 *
 * NOTE: Some of these are none-standard as they're used to control translations
 * for values coming back from the API. Please be mindful of this when altering
 * this object.
 *
 * @public
 */
/**
 * These are the available translatable objects which will be referenced by the
 * SDK internally when templating the UI.
 *
 * NOTE: Some of these are none-standard as they're used to control translations
 * for values coming back from the API. Please be mindful of this when altering
 * this object.
 *
 * @public
 */
export enum TranslationKey {
	REQUIRED_ACTION_KEEP_CAPTURING = 'REQUIRED_ACTION_KeepCapturing',
	REQUIRED_ACTION_STOP_CAPTURING = 'REQUIRED_ACTION_StopCapturing',
	REQUIRED_ACTION_PAUSE_CAPTURING = 'REQUIRED_ACTION_PauseCapturing',
	REQUIRED_ACTION_CLOSE = 'REQUIRED_ACTION_Close',
	REQUIRED_ACTION_ERROR = 'REQUIRED_ACTION_Error',
	REQUIRED_ACTION_AGREE = 'REQUIRED_ACTION_AGREE',
	REQUIRED_ACTION_DISAGREE = 'REQUIRED_ACTION_DISAGREE',
	LIVENESS_ACTION_SMILE = 'LIVENESS_ACTION_Smile',
	LIVENESS_ACTION_FROWN = 'LIVENESS_ACTION_Frown',
	LIVENESS_ACTION_TILT_LEFT = 'LIVENESS_ACTION_Tilt Left',
	LIVENESS_ACTION_TILT_RIGHT = 'LIVENESS_ACTION_Tilt Right',
	LIVENESS_ACTION_TILT_UP = 'LIVENESS_ACTION_Tilt Up',
	LIVENESS_ACTION_TILT_DOWN = 'LIVENESS_ACTION_Tilt Down',
	LIVENESS_ACTION_TILT_STRAIGHT = 'LIVENESS_ACTION_Look Straight',
	LIVENESS_ACTION_NO_ACTION = 'LIVENESS_ACTION_No Action',
	LIVENESS_ACTION_PROCESSING_LIVENESS = 'LIVENESS_ACTION_Processing Liveness',
	LIVENESS_RESULT_FAILED = 'LIVENESS_RESULT_Thank you!.Failed',
	LIVENESS_RESULT_PASSED = 'LIVENESS_RESULT_Thank you!.Passed',
	LIVENESS_RESULT_ACTION_TIMED_OUT = 'LIVENESS_RESULT_Thank you!.ActionTimedOut',
	LIVENESS_RESULT_INTERRUPTED = 'LIVENESS_RESULT_Thank you!.Interrupted',
	LIVENESS_RESULT_UNDEFINED = 'LIVENESS_RESULT_Thank you!.Undefined',
	LIVENESS_ACTION_LOOK_STRAIGHT_TITLE = 'LIVENESS_ACTION_LOOK_STRAIGHT_TITLE',
	LIVENESS_ACTION_LOOK_STRAIGHT_TEXT = 'LIVENESS_ACTION_LOOK_STRAIGHT_TEXT',
	LIVENESS_ACTION_LOOK_LEFT_TITLE = 'LIVENESS_ACTION_LOOK_LEFT_TITLE',
	LIVENESS_ACTION_LOOK_LEFT_TEXT = 'LIVENESS_ACTION_LOOK_LEFT_TEXT',
	LIVENESS_ACTION_LOOK_RIGHT_TITLE = 'LIVENESS_ACTION_LOOK_RIGHT_TITLE',
	LIVENESS_ACTION_LOOK_RIGHT_TEXT = 'LIVENESS_ACTION_LOOK_RIGHT_TEXT',
	LIVENESS_ACTION_LOOK_UP_TITLE = 'LIVENESS_ACTION_LOOK_UP_TITLE',
	LIVENESS_ACTION_LOOK_UP_TEXT = 'LIVENESS_ACTION_LOOK_UP_TEXT',
	LIVENESS_ACTION_LOOK_DOWN_TITLE = 'LIVENESS_ACTION_LOOK_DOWN_TITLE',
	LIVENESS_ACTION_LOOK_DOWN_TEXT = 'LIVENESS_ACTION_LOOK_DOWN_TEXT',
	LIVENESS_ACTION_SMILE_TITLE = 'LIVENESS_ACTION_SMILE_TITLE',
	LIVENESS_ACTION_SMILE_TEXT = 'LIVENESS_ACTION_SMILE_TEXT',
	LIVENESS_ACTION_FROWN_TITLE = 'LIVENESS_ACTION_FROWN_TITLE',
	LIVENESS_ACTION_FROWN_TEXT = 'LIVENESS_ACTION_FROWN_TEXT',
	PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE = 'PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE',
	PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE = 'PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE',
	PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE = 'PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE',
	PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE = 'PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE',
	PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE = 'PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE',
	PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE = 'PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE',
	PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES_TITLE = 'PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES_TITLE',
	PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE = 'PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE',
	PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE = 'PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE',
	PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE = 'PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE',
	PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE = 'PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE',
	PASSIVE_LIVENESS_ERROR_None_TITLE = 'PASSIVE_LIVENESS_ERROR_NONE_TITLE',
	PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE = 'PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE',
	PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE = 'PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE',
	PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE = 'PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE',
	PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE = 'PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE',
	PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE = 'PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE',
	PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE = 'PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE',
	PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE = 'PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE',
	PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE = 'PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE',
	PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE = 'PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE',
	PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE = 'PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE',
	PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER = 'PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER',
	PASSIVE_LIVENESS_ERROR_FACE_CROPPED = 'PASSIVE_LIVENESS_ERROR_FACE_CROPPED',
	PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND = 'PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND',
	PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL = 'PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL',
	PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE = 'PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE',
	PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES = 'PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES',
	PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED = 'PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED',
	PASSIVE_LIVENESS_ERROR_UNKNOWN = 'PASSIVE_LIVENESS_ERROR_UNKNOWN',
	PASSIVE_LIVENESS_ERROR_INTERNAL = 'PASSIVE_LIVENESS_ERROR_INTERNAL',
	PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD = 'PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD',
	PASSIVE_LIVENESS_ERROR_None = 'PASSIVE_LIVENESS_ERROR_NONE',
	PASSIVE_LIVENESS_ERROR_FailedExpressions = 'PASSIVE_LIVENESS_ERROR_FailedExpressions',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE',
	PASSIVE_LIVENESS_ERROR_IMAGE_ERROR = 'PASSIVE_LIVENESS_ERROR_IMAGE_ERROR',
	PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR = 'PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE',
	PASSIVE_LIVENESS_ERROR_INVALID_CONFIG = 'PASSIVE_LIVENESS_ERROR_INVALID_CONFIG',
	PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD = 'PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT',
	PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS = 'PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS',
	PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE = 'PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE',
	PASSIVE_LIVENESS_ERROR_NULLPTR = 'PASSIVE_LIVENESS_ERROR_NULLPTR',
	PASSIVE_LIVENESS_ERROR_LICENSE_ERROR = 'PASSIVE_LIVENESS_ERROR_LICENSE_ERROR',
	PASSIVE_LIVENESS_ERROR_INVALID_META = 'PASSIVE_LIVENESS_ERROR_INVALID_META',
	INITIALIZING_TITLE = 'INITIALIZING_TITLE',
	INITIALIZING_DESCRIPTION = 'INITIALIZING_DESCRIPTION',
	JOURNEY_STATE_STARTED = 'JOURNEY_STATE_STARTED',
	JOURNEY_STATE_IN_PROGRESS = 'JOURNEY_STATE_INPROGRESS',
	JOURNEY_STATE_ENDED = 'JOURNEY_STATE_ENDED',
	INFO_JOURNEY_STATE = 'INFO_JOURNEY_STATE',
	INFO_JOURNEY_ACTION = 'INFO_JOURNEY_ACTION',
	INFO_JOURNEY_ACTION_ATTEMPT = 'INFO_JOURNEY_ACTION_ATTEMPT',
	INFO_JOURNEY_ID = 'INFO_JOURNEY_ID',
	INFO_JOURNEY_RESULT = 'INFO_JOURNEY_RESULT',
	INFO_JOURNEY_REFERENCE = 'INFO_JOURNEY_REFERENCE',
	FLOW_STATE_NONE = 'FLOW_STATE_NONE',
	FLOW_STATE_IDENTITY_FRONT = 'FLOW_STATE_IDENTITY:FRONT',
	FLOW_STATE_IDENTITY_BACK = 'FLOW_STATE_IDENTITY:BACK',
	FLOW_STATE_ADDRESS = 'FLOW_STATE_ADDRESS',
	FLOW_STATE_SELFIE = 'FLOW_STATE_SELFIE',
	FLOW_STATE_LIVENESS = 'FLOW_STATE_LIVENESS',
	FLOW_STATE_COVID = 'FLOW_STATE_COVID',
	PROVIDER_TITLE_CAMERA = 'PROVIDER_TITLE_CAMERA',
	PROVIDER_TITLE_CROPPER = 'PROVIDER_TITLE_CROPPER',
	PROVIDER_TITLE_FILESYSTEM_ID = 'PROVIDER_TITLE_FILESYSTEM_ID',
	PROVIDER_TITLE_FILESYSTEM_FACEMATCH = 'PROVIDER_TITLE_FILESYSTEM_FACEMATCH',
	PROVIDER_TITLE_FILESYSTEM_ADDRESS = 'PROVIDER_TITLE_FILESYSTEM_ADDRESS',
	PROVIDER_TITLE_FILESYSTEM_COVID = 'PROVIDER_TITLE_FILESYSTEM_COVID',
	PROVIDER_TITLE_GATEWAY = 'PROVIDER_TITLE_GATEWAY',
	PROVIDER_TITLE_LIVENESS = 'PROVIDER_TITLE_LIVENESS',
	PROVIDER_TITLE_PASSIVE_LIVENESS = 'PROVIDER_TITLE_PASSIVE_LIVENESS',
	PROVIDER_TITLE_LOGIN = 'PROVIDER_TITLE_LOGIN',
	PROVIDER_TITLE_RESULTS = 'PROVIDER_TITLE_RESULTS',
	PROVIDER_TITLE_SCANNER = 'PROVIDER_TITLE_SCANNER',
	PROVIDER_TITLE_VIEW_ID = 'PROVIDER_TITLE_VIEW_ID',
	PROVIDER_TITLE_VIEW_FACEMATCH = 'PROVIDER_TITLE_VIEW_FACEMATCH',
	PROVIDER_TITLE_VIEW_ADDRESS = 'PROVIDER_TITLE_VIEW_ADDRESS',
	PROVIDER_TITLE_VIEW_COVID = 'PROVIDER_TITLE_VIEW_COVID',
	PROVIDER_SUBTITLE_FILESYSTEM_ID = 'PROVIDER_SUBTITLE_FILESYSTEM_ID',
	PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH = 'PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH',
	PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS = 'PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS',
	PROVIDER_SUBTITLE_FILESYSTEM_COVID = 'PROVIDER_SUBTITLE_FILESYSTEM_COVID',
	PROVIDER_SUBTITLE_SCANNER_ID = 'PROVIDER_SUBTITLE_SCANNER_ID',
	PROVIDER_SUBTITLE_VIEW_ID = 'PROVIDER_SUBTITLE_VIEW_ID',
	PROVIDER_SUBTITLE_VIEW_FACEMATCH = 'PROVIDER_SUBTITLE_VIEW_FACEMATCH',
	PROVIDER_SUBTITLE_VIEW_ADDRESS = 'PROVIDER_SUBTITLE_VIEW_ADDRESS',
	PROVIDER_SUBTITLE_VIEW_COVID = 'PROVIDER_SUBTITLE_VIEW_COVID',
	PROVIDER_TITLE_SMART_CAPTURE = 'PROVIDER_TITLE_SMART_CAPTURE',
	PROVIDER_TITLE_JOURNEY_SELECT = 'PROVIDER_TITLE_JOURNEY_SELECT',
	PROVIDER_TITLE_TERMS_AND_CONDITIONS = 'PROVIDER_TITLE_TERMS_AND_CONDITIONS',
	PROVIDER_TITLE_USER_INPUT = 'PROVIDER_TITLE_USER_INPUT',
	FILESYSTEM_SUPPORTED_TYPES_START = 'FILESYSTEM_SUPPORTED_TYPES_START',
	FILESYSTEM_SUPPORTED_TYPES_END = 'FILESYSTEM_SUPPORTED_TYPES_END',
	FILESYSTEM_SUPPORTED_TYPES_START_SELFIE = 'FILESYSTEM_SUPPORTED_TYPES_START_SELFIE',
	FILESYSTEM_MAX_FILE_SIZE = 'FILESYSTEM_MAX_FILE_SIZE',
	FILESYSTEM_CHECK_FILE_TOO_BIG = 'FILESYSTEM_CHECK_FILE_TOO_BIG',
	FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT = 'FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT',
	FILESYSTEM_IDENTITY_DOCUMENT = 'FILESYSTEM_IDENTITY_DOCUMENT',
	FILESYSTEM_FACEMATCH = 'FILESYSTEM_FACEMATCH',
	FILESYSTEM_ADDRESS = 'FILESYSTEM_ADDRESS',
	FILESYSTEM_COVID = 'FILESYSTEM_COVID',
	FILESYSTEM_DRAG_DROP = 'FILESYSTEM_DRAG_DROP',
	FILESYSTEM_OR = 'FILESYSTEM_OR',
	FILESYSTEM_CHOOSE = 'FILESYSTEM_CHOOSE',
	FILESYSTEM_UPLOADING = 'FILESYSTEM_UPLOADING',
	TRIPLESCAN_GUIDANCE_TRYAGAIN = 'TRIPLESCAN_GUIDANCE_TRYAGAIN',
	FAILURE_REASON_NOT_SUPPORTED = 'FAILURE_REASON_NOT_SUPPORTED',
	FAILURE_REASON_REFER = 'FAILURE_REASON_REFER',
	FAILURE_REASON_EXPIRED = 'FAILURE_REASON_EXPIRED',
	FAILURE_REASON_NOT_ACCEPTED = 'FAILURE_REASON_NOT_ACCEPTED',
	PLEASE_TRY_AGAIN_REFER = 'PLEASE_TRY_AGAIN_REFER',
	PLEASE_TRY_AGAIN_EXPIRED = 'PLEASE_TRY_AGAIN_EXPIRED',
	PLEASE_TRY_AGAIN_NOT_ACCEPTED = 'PLEASE_TRY_AGAIN_NOT_ACCEPTED',
	PLEASE_TRY_AGAIN_NOT_SUPPORTED = 'PLEASE_TRY_AGAIN_NOT_SUPPORTED',
	BLUR_CHECK_REASON = 'BLUR_CHECK_REASON',
	GLARE_CHECK_REASON = 'GLARE_CHECK_REASON',
	RESOLUTION_CHECK_REASON = 'RESOLUTION_CHECK_REASON',
	EDGES_CHECK_REASON = 'EDGES_CHECK_REASON',
	VALIDATION_FAILED = 'VALIDATION_FAILED',
	VALIDATION_FAILED_REASON_DOC_UNKNOWN = 'VALIDATION_FAILED_REASON_DOC_UNKNOWN',
	VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED = 'VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED',
	VALIDATION_FAILED_REASON_DOC_EXPIRED = 'VALIDATION_FAILED_REASON_DOC_EXPIRED',
	PREVIEW_INFO_TITLE_ID = 'PREVIEW_INFO_TITLE_ID',
	PREVIEW_INFO_GOOD = 'PREVIEW_INFO_GOOD',
	PREVIEW_INFO_BAD = 'PREVIEW_INFO_BAD',
	PREVIEW_INFO_GOOD_EXAMPLE_ID = 'PREVIEW_INFO_GOOD_EXAMPLE_ID',
	PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID = 'PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID',
	PREVIEW_INFO_BAD_EXAMPLE_COVER_ID = 'PREVIEW_INFO_BAD_EXAMPLE_COVER_ID',
	PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID = 'PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID',
	PREVIEW_INFO_TITLE_FACEMATCH = 'PREVIEW_INFO_TITLE_FACEMATCH',
	PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH = 'PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH',
	PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH = 'PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH',
	PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH = 'PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH',
	PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH = 'PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH',
	PREVIEW_INFO_TITLE_ADDRESS = 'PREVIEW_INFO_TITLE_ADDRESS',
	PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS = 'PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS',
	PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS = 'PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS',
	PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS = 'PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS',
	PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS = 'PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS',
	PREVIEW_INFO_TITLE_COVID = 'PREVIEW_INFO_TITLE_COVID',
	PREVIEW_INFO_GOOD_EXAMPLE_COVID = 'PREVIEW_INFO_GOOD_EXAMPLE_COVID',
	PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID = 'PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID',
	PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID = 'PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID',
	PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID = 'PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID',
	ATTEMPTS_REMAINING = 'ATTEMPTS_REMAINING',
	CAMERA_CAPTURE = 'CAMERA_CAPTURE',
	CAMERA_CAPTURE_START_BUTTON = 'CAMERA_CAPTURE_START_BUTTON',
	CAMERA_CAPTURE_CAPTION = 'CAMERA_CAPTURE_CAPTION',
	CAMERA_PREVIEW_START = 'CAMERA_PREVIEW_START',
	CAMERA_CONDITION_BLUR = 'CAMERA_CONDITION_BLUR',
	CAMERA_CONDITION_CAPTURING = 'CAMERA_CONDITION_CAPTURING',
	CAMERA_CONDITION_UPLOADING = 'CAMERA_CONDITION_UPLOADING',
	CAMERA_CONDITION_ALIGNMENT = 'CAMERA_CONDITION_ALIGNMENT',
	CAMERA_CONDITION_GLARE = 'CAMERA_CONDITION_GLARE',
	VERIFYING_TITLE = 'VERIFYING_TITLE',
	PREPARING_PREVIEW_TITLE = 'PREPARING_PREVIEW_TITLE',
	CAMERA_CONDITION_LOW_RESOLUTION = 'CAMERA_CONDITION_LOW_RESOLUTION',
	CAMERA_PREVENT_GLARE_HINT = 'CAMERA_PREVENT_GLARE_HINT',
	CAMERA_PREVENT_BLUR_HINT = 'CAMERA_PREVENT_BLUR_HINT',
	CAMERA_PREVENT_LOW_RES_HINT = 'CAMERA_PREVENT_LOW_RES_HINT',
	CAMERA_SMARTCAPTURE_ON = 'CAMERA_SMARTCAPTURE_ON',
	CAMERA_SMARTCAPTURE_OFF = 'CAMERA_SMARTCAPTURE_OFF',
	CAMERA_CAPTURE_FRONT = 'CAMERA_CAPTURE_FRONT',
	CAMERA_MANUAL_CAPTURE_FRONT = 'CAMERA_MANUAL_CAPTURE_FRONT',
	CAMERA_CAPTURE_BACK = 'CAMERA_CAPTURE_BACK',
	CAMERA_CAPTURE_SELFIE_CAPTION = 'CAMERA_CAPTURE_SELFIE_CAPTION',
	CAMERA_CAPTURE_ADDRESS_CAPTION = 'CAMERA_CAPTURE_ADDRESS_CAPTION',
	CAMERA_CAPTURE_COVID_CAPTION = 'CAMERA_CAPTURE_COVID_CAPTION',
	CAMERA_LOADING = 'CAMERA_LOADING',
	CROPPER_RETRY = 'CROPPER_RETRY',
	CROPPER_UPLOAD = 'CROPPER_UPLOAD',
	CROPPER_UPLOADING = 'CROPPER_UPLOADING',
	FILESYSTEM_SELECT = 'FILESYSTEM_SELECT',
	FILESYSTEM_DROP_IMAGE = 'FILESYSTEM_DROP_IMAGE',
	GATEWAY_CAMERA = 'GATEWAY_CAMERA',
	GATEWAY_CANCEL = 'GATEWAY_CANCEL',
	LIVENESS_START = 'LIVENESS_START',
	PASSIVE_LIVENESS_START = 'PASSIVE_LIVENESS_START',
	LOGIN_USERNAME = 'LOGIN_USERNAME',
	LOGIN_PASSWORD = 'LOGIN_PASSWORD',
	LOGIN_SUBMIT = 'LOGIN_SUBMIT',
	RESULTS_DOCUMENTS = 'RESULTS_DOCUMENTS',
	RESULTS_DOCUMENTS_NONE = 'RESULTS_DOCUMENTS_NONE',
	RESULTS_DOCUMENT_TYPE = 'RESULTS_DOCUMENT_TYPE',
	RESULTS_DOCUMENT_RESULT = 'RESULTS_DOCUMENT_RESULT',
	RESULTS_EXTRACTED_FIELDS_NONE = 'RESULTS_EXTRACTED_FIELDS_NONE',
	RESULTS_DETAILS = 'RESULTS_DETAILS',
	RESULTS_DETAILS_NONE = 'RESULTS_DETAILS_NONE',
	RESULTS_NEW_JOURNEY = 'RESULTS_NEW_JOURNEY',
	RESULTS_NO_INFORMATION = 'RESULTS_NO_INFORMATION',
	RESULTS_LOGOUT = 'RESULTS_LOGOUT',
	RESULTS_HIGH_LEVEL_ABORTED = 'RESULTS_HIGH_LEVEL_Aborted',
	RESULTS_HIGH_LEVEL_TCCDISAGREE = 'RESULTS_HIGH_LEVEL_TCCDisagree',
	RESULTS_HIGH_LEVEL_EXPIRED = 'RESULTS_HIGH_LEVEL_Expired',
	RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE = 'RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE',
	RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE = 'RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE',
	RESULTS_HIGH_LEVEL_NOT_ACCEPTED = 'RESULTS_HIGH_LEVEL_NotAccepted',
	RESULTS_HIGH_LEVEL_NOT_SUPPORTED = 'RESULTS_HIGH_LEVEL_NotSupported',
	RESULTS_HIGH_LEVEL_NOTSUPPORTED = 'RESULTS_HIGH_LEVEL_Notsupported',
	RESULTS_HIGH_LEVEL_PASSED = 'RESULTS_HIGH_LEVEL_Passed',
	RESULTS_HIGH_LEVEL_REFER = 'RESULTS_HIGH_LEVEL_Refer',
	RESULTS_HIGH_LEVEL_UNDEFINED = 'RESULTS_HIGH_LEVEL_Undefined',
	RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVE_LIVENESS_RESULT = 'RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT',
	RESULTS_HIGH_LEVEL_DETAIL_DOCUMENT_FRONT_SIDE_TYPE_CHECK = 'RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK',
	RESULTS_HIGH_LEVEL_DETAIL_DOCUMENT_BACK_SIDE_TYPE_CHECK = 'RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDETYPECHECK',
	RESULTS_HIGH_LEVEL_DETAIL_DOCUMENT_BACK_SIDE_CHECK = 'RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK',
	RESULTS_HIGH_LEVEL_DETAIL_DOCUMENT_BLOCKING_POLICY = 'RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY',
	RESULTS_HIGH_LEVEL_DETAIL_DOCUMENT_OVERALL_VALIDATION = 'RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTOVERALLVALIDATION',
	RESULTS_HIGH_LEVEL_DETAIL_DOCUMENT_EXPIRY = 'RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY',
	RESULTS_HIGH_LEVEL_DETAIL_DOCUMENT_SUPPORT = 'RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT',
	RESULTS_HIGH_LEVEL_DETAIL_DOCUMENT_VALIDATION = 'RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION',
	RESULTS_HIGH_LEVEL_DETAIL_DOCUMENT_PROOF_POLICY = 'RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY',
	RESULTS_HIGH_LEVEL_DETAIL_FACEMATCH_VALIDATION = 'RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION',
	RESULTS_HIGH_LEVEL_DETAIL_UNDERAGE_RULE = 'RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE',
	RESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED = 'RESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESSNEEDED',
	RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED = 'RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED',
	RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED = 'RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED',
	RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED = 'RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED',
	RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED = 'RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED',
	RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED = 'RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED',
	RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK = 'RESULTS_HIGH_LEVEL_DETAIL_COVIDPASSCROSSCHECKRESULT',
	RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK = 'RESULTS_HIGH_LEVEL_DETAIL_DATACHECKSRESULT',
	ADDITIONAL_CHECKS_DETAILS = 'ADDITIONAL_CHECKS_DETAILS',
	ADDITIONAL_CHECKS_DETAILS_NONE = 'ADDITIONAL_CHECKS_DETAILS_NONE',
	ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK = 'ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK',
	ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA = 'ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA',
	ADDITIONAL_CHECKS_DETAIL_DATACHECKS = 'ADDITIONAL_CHECKS_DETAIL_DATACHECKS',
	GBG_SCORES = 'GBG_SCORES',
	GBG_TRUST_SCORE = 'GBG_TRUST_SCORE',
	GBG_SCORE = 'GBG_SCORE',
	VIEW_RETRY = 'VIEW_RETRY',
	VIEW_CROP = 'VIEW_CROP',
	VIEW_CROPPING = 'VIEW_CROPPING',
	VIEW_UPLOAD = 'VIEW_UPLOAD',
	VIEW_UPLOADING = 'VIEW_UPLOADING',
	SMART_CAPTURE_INITIALIZING = 'SMART_CAPTURE_INITIALIZING',
	SMART_CAPTURE_START = 'SMART_CAPTURE_START',
	SCANNER_DESC_AVAILABLE = 'SCANNER_DESC_AVAILABLE',
	SCANNER_DESC_PROCESSING = 'SCANNER_DESC_PROCESSING',
	SCANNER_DESC_SCANNING = 'SCANNER_DESC_SCANNING',
	SCANNER_DESC_DISCONNECTED = 'SCANNER_DESC_DISCONNECTED',
	SCANNER_DESC_NOT_CONNECTED = 'SCANNER_DESC_NOT_CONNECTED',
	SCANNER_DESC_OFFLINE = 'SCANNER_DESC_OFFLINE',
	SCANNER_DESC_BUSY = 'SCANNER_DESC_BUSY',
	SCANNER_DESC_WAITING = 'SCANNER_DESC_WAITING',
	SCANNER_DESC_LOADING = 'SCANNER_DESC_LOADING',
	SCANNER_TITLE_AVAILABLE = 'SCANNER_TITLE_AVAILABLE',
	SCANNER_TITLE_PROCESSING = 'SCANNER_TITLE_PROCESSING',
	SCANNER_TITLE_SCANNING = 'SCANNER_TITLE_SCANNING',
	SCANNER_TITLE_DISCONNECTED = 'SCANNER_TITLE_DISCONNECTED',
	SCANNER_TITLE_NOT_CONNECTED = 'SCANNER_TITLE_NOT_CONNECTED',
	SCANNER_TITLE_OFFLINE = 'SCANNER_TITLE_OFFLINE',
	SCANNER_TITLE_BUSY = 'SCANNER_TITLE_BUSY',
	SCANNER_TITLE_WAITING = 'SCANNER_TITLE_WAITING',
	SCANNER_ACTION_REGISTER = 'SCANNER_ACTION_REGISTER',
	SCANNER_ACTION_RELEASE = 'SCANNER_ACTION_RELEASE',
	CANCEL_JOURNEY = 'CANCEL_JOURNEY',
	MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE = 'MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE',
	MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE = 'MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE',
	JOURNEY_SELECT_CONTINUE = 'JOURNEY_SELECT_CONTINUE',

	HELP_MODAL_AUTOCAPTURE_TITLE = 'HELP_MODAL_AUTOCAPTURE_TITLE',
	HELP_MODAL_AUTOCAPTURE_SUBTITLE = 'HELP_MODAL_AUTOCAPTURE_SUBTITLE',
	HELP_MODAL_AUTOCAPTURE_TIPS = 'HELP_MODAL_AUTOCAPTURE_TIPS',
	HELP_MODAL_AUTOCAPTURE_GLARE_TITLE = 'HELP_MODAL_AUTOCAPTURE_GLARE_TITLE',
	HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE = 'HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE',
	HELP_MODAL_AUTOCAPTURE_FAR_TITLE = 'HELP_MODAL_AUTOCAPTURE_FAR_TITLE',
	HELP_MODAL_AUTOCAPTURE_FAR_SUBTITLE = 'HELP_MODAL_AUTOCAPTURE_FAR_SUBTITLE',
	HELP_MODAL_AUTOCAPTURE_BLUR_TITLE = 'HELP_MODAL_AUTOCAPTURE_BLUR_TITLE',
	HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE = 'HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE',
	HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE = 'HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE',
	HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE = 'HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE',

	HELP_MODAL_SELFIE_TITLE = 'HELP_MODAL_SELFIE_TITLE',
	HELP_MODAL_SELFIE_SUBTITLE = 'HELP_MODAL_SELFIE_SUBTITLE',

	HELP_MODAL_POA_TITLE = 'HELP_MODAL_POA_TITLE',
	HELP_MODAL_POA_SUBTITLE = 'HELP_MODAL_POA_SUBTITLE',
	HELP_MODAL_POA_TIPS = 'HELP_MODAL_POA_TIPS',
	HELP_MODAL_POA_GLARE_TITLE = 'HELP_MODAL_POA_GLARE_TITLE',
	HELP_MODAL_POA_GLARE_SUBTITLE = 'HELP_MODAL_POA_GLARE_SUBTITLE',
	HELP_MODAL_POA_FAR_TITLE = 'HELP_MODAL_POA_FAR_TITLE',
	HELP_MODAL_POA_FAR_SUBTITLE = 'HELP_MODAL_POA_FAR_SUBTITLE',
	HELP_MODAL_POA_BLUR_TITLE = 'HELP_MODAL_POA_BLUR_TITLE',
	HELP_MODAL_POA_BLUR_SUBTITLE = 'HELP_MODAL_POA_BLUR_SUBTITLE',
	HELP_MODAL_POA_MANUAL_CAPTURE = 'HELP_MODAL_POA_MANUAL_CAPTURE',
	HELP_MODAL_POA_TURN_MANUAL_CAPTURE = 'HELP_MODAL_POA_TURN_MANUAL_CAPTURE',

	HELP_MODAL_COVID_TITLE = 'HELP_MODAL_COVID_TITLE',
	HELP_MODAL_COVID_SUBTITLE = 'HELP_MODAL_COVID_SUBTITLE',
	HELP_MODAL_COVID_TIPS = 'HELP_MODAL_COVID_TIPS',
	HELP_MODAL_COVID_GLARE_TITLE = 'HELP_MODAL_COVID_GLARE_TITLE',
	HELP_MODAL_COVID_GLARE_SUBTITLE = 'HELP_MODAL_COVID_GLARE_SUBTITLE',
	HELP_MODAL_COVID_FAR_TITLE = 'HELP_MODAL_COVID_FAR_TITLE',
	HELP_MODAL_COVID_FAR_SUBTITLE = 'HELP_MODAL_COVID_FAR_SUBTITLE',
	HELP_MODAL_COVID_BLUR_TITLE = 'HELP_MODAL_COVID_BLUR_TITLE',
	HELP_MODAL_COVID_BLUR_SUBTITLE = 'HELP_MODAL_COVID_BLUR_SUBTITLE',
	HELP_MODAL_COVID_MANUAL_CAPTURE = 'HELP_MODAL_COVID_MANUAL_CAPTURE',
	HELP_MODAL_COVID_TURN_MANUAL_CAPTURE = 'HELP_MODAL_COVID_TURN_MANUAL_CAPTURE',

	HELP_MODAL_NEED_HELP = 'HELP_MODAL_NEED_HELP',
	// Exceptions below here...
	EXCEPTION = 'EXCEPTION',
	EXCEPTION_AUTHORIZATION = 'EXCEPTION_AUTHORIZATION',
	EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED = 'EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED',
	EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID = 'EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID',
	EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED = 'EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED',
	EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED = 'EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED',
	EXCEPTION_BAD_REQUEST = 'EXCEPTION_BAD_REQUEST',
	EXCEPTION_BAD_REQUEST_INVALID_IMAGE = 'EXCEPTION_BAD_REQUEST_INVALID_IMAGE',
	EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE = 'EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE',
	EXCEPTION_FLOW_STATE_JOURNEY_ENDED = 'EXCEPTION_FLOW_STATE_JOURNEY_ENDED',
	EXCEPTION_FLOW_STATE_MISSING = 'EXCEPTION_FLOW_STATE_MISSING',
	EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION = 'EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION',
	EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING = 'EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING',
	EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER = 'EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER',
	EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER = 'EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER',
	EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR = 'EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR',
	EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID = 'EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID',
	EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED = 'EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED',
	EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING = 'EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING',
	EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING = 'EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING',
	EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING = 'EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING',
	EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING = 'EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING',
	EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING = 'EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING',
	EXCEPTION_MISSING_REQUIRED_FIELD_MISSING = 'EXCEPTION_MISSING_REQUIRED_FIELD_MISSING',
	EXCEPTION_POSTCODE_FORMAT_ERROR = 'EXCEPTION_POSTCODE_FORMAT_ERROR',
	EXCEPTION_HOUSENUMBER_FORMAT_ERROR = 'EXCEPTION_HOUSENUMBER_FORMAT_ERROR',
	EXCEPTION_STREETNAME_FORMAT_ERROR = 'EXCEPTION_STREETNAME_FORMAT_ERROR',
	EXCEPTION_TOWN_FORMAT_ERROR = 'EXCEPTION_TOWN_FORMAT_ERROR',
	EXCEPTION_JOURNEY_DEFINITIONS_MISSING = 'EXCEPTION_JOURNEY_DEFINITIONS_MISSING',
	EXCEPTION_NETWORK = 'EXCEPTION_NETWORK',
	EXCEPTION_PLATFORM_BROWSER_ONLY = 'EXCEPTION_PLATFORM_BROWSER_ONLY',
	EXCEPTION_PLATFORM_UNSUPPORTED = 'EXCEPTION_PLATFORM_UNSUPPORTED',
	EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED = 'EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED',
	EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE = 'EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE',
	EXCEPTION_PLATFORM_CAMERA_NOT_READABLE = 'EXCEPTION_PLATFORM_CAMERA_NOT_READABLE',
	EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE = 'EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE',
	EXCEPTION_SERVER = 'EXCEPTION_SERVER',
	EXCEPTION_SERVER_UNREACHABLE = 'EXCEPTION_SERVER_UNREACHABLE',
	EXCEPTION_SERVER_DATA_NOT_PERSISTED = 'EXCEPTION_SERVER_DATA_NOT_PERSISTED',
	EXCEPTION_SERVER_RESULT_NOT_PASSING = 'EXCEPTION_SERVER_RESULT_NOT_PASSING',
	EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE = 'EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE',
	EXCEPTION_TEMPLATE_CONTAINER_MISSING = 'EXCEPTION_TEMPLATE_CONTAINER_MISSING',
	EXCEPTION_TEMPLATE_ELEMENTS_MISSING = 'EXCEPTION_TEMPLATE_ELEMENTS_MISSING',
	EXCEPTION_TEMPLATE_MISSING = 'EXCEPTION_TEMPLATE_MISSING',
	EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING = 'EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING',
	EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE = 'EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE',
	EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED = 'EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED',
	EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE = 'EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE',
	SUPPORTED_DOCUMENT_ACCOUNT_STATEMENT = 'SUPPORTED_DOCUMENT_Account Statement',
	SUPPORTED_DOCUMENT_AGREEMENT_TENANCY = 'SUPPORTED_DOCUMENT_Agreement (Tenancy)',
	SUPPORTED_DOCUMENT_BANK_DOCUMENT = 'SUPPORTED_DOCUMENT_Bank Document',
	SUPPORTED_DOCUMENT_BANK_LETTER = 'SUPPORTED_DOCUMENT_Bank Letter',
	SUPPORTED_DOCUMENT_BANK_STATEMENT = 'SUPPORTED_DOCUMENT_Bank Statement',
	SUPPORTED_DOCUMENT_BENEFIT_LETTER = 'SUPPORTED_DOCUMENT_Benefit Letter',
	SUPPORTED_DOCUMENT_CERTIFICATE = 'SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)',
	SUPPORTED_DOCUMENT_COUNCIL_DOCUMENT = 'SUPPORTED_DOCUMENT_Council Document',
	SUPPORTED_DOCUMENT_COUNCIL_LETTER = 'SUPPORTED_DOCUMENT_Council Letter',
	SUPPORTED_DOCUMENT_COUNCIL_TAX = 'SUPPORTED_DOCUMENT_Council Tax',
	SUPPORTED_DOCUMENT_DRIVING_LICENSE = 'SUPPORTED_DOCUMENT_Driving License',
	SUPPORTED_DOCUMENT_DRIVING_LICENCE = 'SUPPORTED_DOCUMENT_Driving Licence',
	SUPPORTED_DOCUMENT_DWP_DOCUMENT = 'SUPPORTED_DOCUMENT_DWP Document',
	SUPPORTED_DOCUMENT_HMRC_DOCUMENT = 'SUPPORTED_DOCUMENT_HMRC Document',
	SUPPORTED_DOCUMENT_INFORMATION_SHEET = 'SUPPORTED_DOCUMENT_Information Sheet',
	SUPPORTED_DOCUMENT_INSURANCE_DOCUMENT = 'SUPPORTED_DOCUMENT_Insurance Document',
	SUPPORTED_DOCUMENT_INSURANCE_LETTER = 'SUPPORTED_DOCUMENT_Insurance Letter',
	SUPPORTED_DOCUMENT_INVOICE = 'SUPPORTED_DOCUMENT_Invoice',
	SUPPORTED_DOCUMENT_NIC_LETTER = 'SUPPORTED_DOCUMENT_NIC Letter',
	SUPPORTED_DOCUMENT_NINO_LETTER = 'SUPPORTED_DOCUMENT_NINO Letter',
	SUPPORTED_DOCUMENT_OFFICIAL_DOCUMENT = 'SUPPORTED_DOCUMENT_Official Document',
	SUPPORTED_DOCUMENT_OFFICIAL_LETTER = 'SUPPORTED_DOCUMENT_Official Letter',
	SUPPORTED_DOCUMENT_REPAYMENT = 'SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)',
	SUPPORTED_DOCUMENT_TAX_LETTER = 'SUPPORTED_DOCUMENT_Tax Letter',
	SUPPORTED_DOCUMENT_TAX_STATEMENT = 'SUPPORTED_DOCUMENT_Tax Statement',
	SUPPORTED_DOCUMENT_TEL_BILL = 'SUPPORTED_DOCUMENT_Tel Bill',
	SUPPORTED_DOCUMENT_TEL_LETTER = 'SUPPORTED_DOCUMENT_Tel Letter',
	SUPPORTED_DOCUMENT_TELECOMMUNICATION_DOCUMENT = 'SUPPORTED_DOCUMENT_Telecommunication Document',
	SUPPORTED_DOCUMENT_TV_LICENSE = 'SUPPORTED_DOCUMENT_TV Licence',
	SUPPORTED_DOCUMENT_UNIVERSITY_LETTER = 'SUPPORTED_DOCUMENT_University Letter',
	SUPPORTED_DOCUMENT_UTILITY_BILL = 'SUPPORTED_DOCUMENT_Utility Bill',
	SUPPORTED_DOCUMENT_UTILITY_DOCUMENT = 'SUPPORTED_DOCUMENT_Utility Document',
	SUPPORTED_DOCUMENT_UTILITY_LETTER = 'SUPPORTED_DOCUMENT_Utility Letter',
	SUPPORTED_DOCUMENT_WATER_BILL = 'SUPPORTED_DOCUMENT_Water Bil',
	SUPPORTED_DOCUMENT_WATER_DOCUMENT = 'SUPPORTED_DOCUMENT_Water Document',
	SUPPORTED_DOCUMENT_AGENTS_LICENCE = 'SUPPORTED_DOCUMENT_Agents License',
	SUPPORTED_DOCUMENT_ELECTORAL_CARD = 'SUPPORTED_DOCUMENT_Electoral Card',
	SUPPORTED_DOCUMENT_FOREIGNER_IDENTIFICATION_CARD = 'SUPPORTED_DOCUMENT_Foreigner Identification Card',
	SUPPORTED_DOCUMENT_HEALTH_CARD = 'SUPPORTED_DOCUMENT_Health Card',
	SUPPORTED_DOCUMENT_JOB_LICENCE = 'SUPPORTED_DOCUMENT_Job License ',
	SUPPORTED_DOCUMENT_MEMBERSHIP_IDENTIFICATION_CARD = 'SUPPORTED_DOCUMENT_Membership Identification Card',
	SUPPORTED_DOCUMENT_MILITARY_IDENTIFICATION_CARD = 'SUPPORTED_DOCUMENT_Military Identification Card',
	SUPPORTED_DOCUMENT_NATIONAL_IDENTIFICATION_CARD = 'SUPPORTED_DOCUMENT_National Identification Card',
	SUPPORTED_DOCUMENT_PASSPORT = 'SUPPORTED_DOCUMENT_Passport',
	SUPPORTED_DOCUMENT_TRAVEL_PERMIT = 'SUPPORTED_DOCUMENT_Travel Permit',
	SUPPORTED_DOCUMENT_VISA = 'SUPPORTED_DOCUMENT_Visa',
	SUPPORTED_DOCUMENT_WEAPONS_LICENCE = 'SUPPORTED_DOCUMENT_Weapons Licence',
	SUPPORTED_DOCUMENT_SELFIE_PHOTO = 'SUPPORTED_DOCUMENT_Selfie Photo',
	SUPPORTED_DOCUMENT_DATACHECKS = 'SUPPORTED_DOCUMENT_DataChecks',
	SUPPORTED_DOCUMENT_UNKNOWN = 'SUPPORTED_DOCUMENT_Unknown',
	SUPPORTED_DOCUMENT_COVIDPASS = 'SUPPORTED_DOCUMENT_CovidPass',
	EXTRACTED_FIELDS_ADDRESS_FULL = 'EXTRACTED_FIELDS_AddressFull',
	EXTRACTED_FIELDS_ADDRESS_CITY = 'EXTRACTED_FIELDS_AddressCity',
	EXTRACTED_FIELDS_ADDRESS_POSTCODE = 'EXTRACTED_FIELDS_AddressPostCode',
	EXTRACTED_FIELDS_LASTNAME_FIRST_PART = 'EXTRACTED_FIELDS_LastNameFirstPart',
	EXTRACTED_FIELDS_SEX = 'EXTRACTED_FIELDS_Sex',
	EXTRACTED_FIELDS_BIRTH_PLACE = 'EXTRACTED_FIELDS_BirthPlace',
	EXTRACTED_FIELDS_ISSUE_NUMBER = 'EXTRACTED_FIELDS_IssueNumber',
	EXTRACTED_FIELDS_DOCUMENT_NUMBER_CHECK_DIGIT = 'EXTRACTED_FIELDS_DocumentNumberCheckDigit',
	EXTRACTED_FIELDS_BIRTH_DATE = 'EXTRACTED_FIELDS_BirthDate',
	EXTRACTED_FIELDS_DOCUMENT_NUMBER = 'EXTRACTED_FIELDS_DocumentNumber',
	EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT = 'EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT',
	EXTRACTED_FIELDS_FIRST_NAME = 'EXTRACTED_FIELDS_FirstName',
	EXTRACTED_FIELDS_ARBITRARY_DIGIT = 'EXTRACTED_FIELDS_ArbitraryDigit',
	EXTRACTED_FIELDS_FIRST_NAME_INITIAL = 'EXTRACTED_FIELDS_FirstNameInitial',
	EXTRACTED_FIELDS_EXPIRY_DATE = 'EXTRACTED_FIELDS_ExpiryDate',
	EXTRACTED_FIELDS_ISSUE_DATE = 'EXTRACTED_FIELDS_IssueDate',
	EXTRACTED_FIELDS_LAST_NAME = 'EXTRACTED_FIELDS_LastName',
	EXTRACTED_FIELDS_LICENSE_CATEGORY = 'EXTRACTED_FIELDS_LicenseCategory',
	EXTRACTED_FIELDS_DOCUMENT_CATEGORY = 'EXTRACTED_FIELDS_DocumentCategory',
	EXTRACTED_FIELDS_DOCUMENT_TYPE = 'EXTRACTED_FIELDS_DocumentType',
	EXTRACTED_FIELDS_DOCUMENT_SUB_TYPE = 'EXTRACTED_FIELDS_DocumentSubType',
	EXTRACTED_FIELDS_NATIONALITY_CODE = 'EXTRACTED_FIELDS_NationalityCode',
	EXTRACTED_FIELDS_MIDDLE_NAME = 'EXTRACTED_FIELDS_MiddleName',
	EXTRACTED_FIELDS_FIRST_ISSUANCE_DATE = 'EXTRACTED_FIELDS_FirstIssuanceDate',
	EXTRACTED_FIELDS_SECOND_LAST_NAME = 'EXTRACTED_FIELDS_SecondLastName',
	EXTRACTED_FIELDS_FULL_NAME = 'EXTRACTED_FIELDS_FullName',
	EXTRACTED_FIELDS_PERSONAL_NUMBER = 'EXTRACTED_FIELDS_PersonalNumber',
	EXTRACTED_FIELDS_NATIONALITY_NAME = 'EXTRACTED_FIELDS_NationalityName',
	EXTRACTED_FIELDS_BARCODE_ITEMS = 'EXTRACTED_FIELDS_BarcodeItems',
	EXTRACTED_FIELDS_BIRTH_PLACE_CITY = 'EXTRACTED_FIELDS_BirthPlaceCity',
	EXTRACTED_FIELDS_BIRTH_PLACE_STATE = 'EXTRACTED_FIELDS_BirthPlaceState',
	EXTRACTED_FIELDS_BIRTH_PLACE_COUNTRY = 'EXTRACTED_FIELDS_BirthPlaceCountry',
	EXTRACTED_FIELDS_MRZ_FULL = 'EXTRACTED_FIELDS_MRZFull',
	EXTRACTED_FIELDS_MRZ_LINE_1 = 'EXTRACTED_FIELDS_MRZLine1',
	EXTRACTED_FIELDS_MRZ_LINE_2 = 'EXTRACTED_FIELDS_MRZLine2',
	EXTRACTED_FIELDS_MRZ_LINE_3 = 'EXTRACTED_FIELDS_MRZLine3',
	EXTRACTED_FIELDS_OBSERVATION_PAGE = 'EXTRACTED_FIELDS_ObservationPage',
	EXTRACTED_FIELDS_ISSUING_AUTHORITY = 'EXTRACTED_FIELDS_IssuingAuthority',
	EXTRACTED_FIELDS_ISSUING_LOCATION = 'EXTRACTED_FIELDS_IssuingLocation',
	EXTRACTED_FIELDS_MARITAL_STATUS = 'EXTRACTED_FIELDS_MaritalStatus',
	EXTRACTED_FIELDS_OCCUPATION = 'EXTRACTED_FIELDS_Occupation',
	EXTRACTED_FIELDS_ALIEN_NUMBER = 'EXTRACTED_FIELDS_AlienNumber',
	EXTRACTED_FIELDS_EMPLOYER = 'EXTRACTED_FIELDS_Employer',
	EXTRACTED_FIELDS_ADDRESS_LINE_1 = 'EXTRACTED_FIELDS_AddressLine1',
	EXTRACTED_FIELDS_ADDRESS_LINE_2 = 'EXTRACTED_FIELDS_AddressLine2',
	EXTRACTED_FIELDS_ADDRESS_LINE_3 = 'EXTRACTED_FIELDS_AddressLine3',
	EXTRACTED_FIELDS_ADDRESS_LINE_4 = 'EXTRACTED_FIELDS_AddressLine4',
	EXTRACTED_FIELDS_ADDRESS_STATE = 'EXTRACTED_FIELDS_AddressState',
	EXTRACTED_FIELDS_ADDRESS_DISTRICT = 'EXTRACTED_FIELDS_AddressDistrict',
	EXTRACTED_FIELDS_ADDRESS_BUILDING_NUM = 'EXTRACTED_FIELDS_AddressBuildingNumber',
	EXTRACTED_FIELDS_ADDRESS_BUILDING_NAME = 'EXTRACTED_FIELDS_AddressBuildingName',
	EXTRACTED_FIELDS_ADDRESS_STREET = 'EXTRACTED_FIELDS_AddressStreet',
	EXTRACTED_FIELDS_ADDRESS_COUNTRY = 'EXTRACTED_FIELDS_AddressCountry',
	EXTRACTED_FIELDS_REF_ADDRESS_FULL = 'EXTRACTED_FIELDS_RefAddressFull',
	EXTRACTED_FIELDS_REF_ADDRESS_LINE_1 = 'EXTRACTED_FIELDS_RefAddressLine1',
	EXTRACTED_FIELDS_REF_ADDRESS_LINE_2 = 'EXTRACTED_FIELDS_RefAddressLine2',
	EXTRACTED_FIELDS_REF_ADDRESS_LINE_3 = 'EXTRACTED_FIELDS_RefAddressLine3',
	EXTRACTED_FIELDS_REF_ADDRESS_LINE_4 = 'EXTRACTED_FIELDS_RefAddressLine4',
	EXTRACTED_FIELDS_REF_ADDRESS_CITY = 'EXTRACTED_FIELDS_RefAddressCity',
	EXTRACTED_FIELDS_REF_ADDRESS_STATE = 'EXTRACTED_FIELDS_RefAddressState',
	EXTRACTED_FIELDS_REF_ADDRESS_DISTRICT = 'EXTRACTED_FIELDS_RefAddressDistrict',
	EXTRACTED_FIELDS_REF_ADDRESS_BUILTING_NUM = 'EXTRACTED_FIELDS_RefAddressBuildingNumber',
	EXTRACTED_FIELDS_REF_ADDRESS_BUILDING_NAME = 'EXTRACTED_FIELDS_RefAddressBuildingName',
	EXTRACTED_FIELDS_REF_ADDRESS_SUB_BUILDING_NAME = 'EXTRACTED_FIELDS_RefAddressSubBuildingName',
	EXTRACTED_FIELDS_REF_ADDRESS_STREET = 'EXTRACTED_FIELDS_RefAddressStreet',
	EXTRACTED_FIELDS_REF_ADDRESS_COUNTRY = 'EXTRACTED_FIELDS_RefAddressCountry',
	EXTRACTED_FIELDS_REF_ADDRESS_POST_CODE = 'EXTRACTED_FIELDS_RefAddressPostCode',
	EXTRACTED_FIELDS_HEALTH_NUMBER = 'EXTRACTED_FIELDS_HealthNumber',
	EXTRACTED_FIELDS_ENDORSMENTS = 'EXTRACTED_FIELDS_Endorsements',
	EXTRACTED_FIELDS_CONSTRAINTS = 'EXTRACTED_FIELDS_Constraints',
	EXTRACTED_FIELDS_LICENSE_MARINE = 'EXTRACTED_FIELDS_LicenseMarine',
	EXTRACTED_FIELDS_HEIGHT = 'EXTRACTED_FIELDS_Height',
	EXTRACTED_FIELDS_WEIGHT = 'EXTRACTED_FIELDS_Weight',
	EXTRACTED_FIELDS_HAIR_COLOR = 'EXTRACTED_FIELDS_HairColor',
	EXTRACTED_FIELDS_EYE_COLOR = 'EXTRACTED_FIELDS_EyeColor',
	EXTRACTED_FIELDS_LENS_DATA = 'EXTRACTED_FIELDS_LensData',
	EXTRACTED_FIELDS_SOCIAL_SECURITY_NUM = 'EXTRACTED_FIELDS_SocialSecurityNumber',
	EXTRACTED_FIELDS_NATIONAL_INSURANCE_NUM = 'EXTRACTED_FIELDS_NationalInsuranceNumber',
	EXTRACTED_FIELDS_RACE = 'EXTRACTED_FIELDS_Race',
	EXTRACTED_FIELDS_MOTHER_NAME = 'EXTRACTED_FIELDS_MotherName',
	EXTRACTED_FIELDS_FATHER_NAME = 'EXTRACTED_FIELDS_FatherName',
	EXTRACTED_FIELDS_PARENTS = 'EXTRACTED_FIELDS_Parents',
	EXTRACTED_FIELDS_REMARKS = 'EXTRACTED_FIELDS_Remarks',
	EXTRACTED_FIELDS_DISTINGUISHING_MARKS = 'EXTRACTED_FIELDS_DistinguishingMarks',
	EXTRACTED_FIELDS_PERIOD_OF_STAY = 'EXTRACTED_FIELDS_PeriodOfStay',
	EXTRACTED_FIELDS_TAX_NUMBER = 'EXTRACTED_FIELDS_TaxNumber',
	EXTRACTED_FIELDS_DONOR = 'EXTRACTED_FIELDS_Donor',
	EXTRACTED_FIELDS_RFIDG1 = 'EXTRACTED_FIELDS_RFIDG1',
	EXTRACTED_FIELDS_RFIDG2 = 'EXTRACTED_FIELDS_RFIDG2',
	EXTRACTED_FIELDS_RFIDG3 = 'EXTRACTED_FIELDS_RFIDG3',
	EXTRACTED_FIELDS_RFIDG15 = 'EXTRACTED_FIELDS_RFIDG15',
	EXTRACTED_FIELDS_RFIDSOD = 'EXTRACTED_FIELDS_RFIDSOD',
	EXTRACTED_FIELDS_PORTRAIT_PHOTO = 'EXTRACTED_FIELDS_PortraitPhoto',
	EXTRACTED_FIELDS_TITLE = 'EXTRACTED_FIELDS_Title',
	EXTRACTED_FIELDS_ISSUE_DATE_2 = 'EXTRACTED_FIELDS_IssueDate2',
	EXTRACTED_FIELDS_EXPIRY_DATE_2 = 'EXTRACTED_FIELDS_ExpiryDate2',
	EXTRACTED_FIELDS_LICENSE_CATEGORY_2 = 'EXTRACTED_FIELDS_LicenseCategory2',
	EXTRACTED_FIELDS_ISSUE_DATE_3 = 'EXTRACTED_FIELDS_IssueDate3',
	EXTRACTED_FIELDS_EXPIRY_DATE_3 = 'EXTRACTED_FIELDS_ExpiryDate3',
	EXTRACTED_FIELDS_LICENSE_CATEGORY_3 = 'EXTRACTED_FIELDS_LicenseCategory3',
	EXTRACTED_FIELDS_ISSUE_DATE_4 = 'EXTRACTED_FIELDS_IssueDate4',
	EXTRACTED_FIELDS_EXPIRY_DATE_4 = 'EXTRACTED_FIELDS_ExpiryDate4',
	EXTRACTED_FIELDS_LICENSE_CATEGORY_4 = 'EXTRACTED_FIELDS_LicenseCategory4',
	EXTRACTED_FIELDS_MRZ_CODE_1 = 'EXTRACTED_FIELDS_MRZCode1',
	EXTRACTED_FIELDS_MRZ_CODE_2 = 'EXTRACTED_FIELDS_MRZCode2',
	EXTRACTED_FIELDS_MRZ_STANDARD_TYPE = 'EXTRACTED_FIELDS_MRZStandardType',
	EXTRACTED_FIELDS_ADDRESS_STREET_SUFFIX = 'EXTRACTED_FIELDS_AddressStreetSuffix',
	EXTRACTED_FIELDS_ADDRESS_STREET_TYPE = 'EXTRACTED_FIELDS_AddressStreetType',
	EXTRACTED_FIELDS_ADDRESS_UNIT_NUMBER = 'EXTRACTED_FIELDS_AddressUnitNumber',
	EXTRACTED_FIELDS_LICENSE_NUMBER = 'EXTRACTED_FIELDS_LicenseNumber',
	EXTRACTED_FIELDS_ADDRESS_STATE_CODE = 'EXTRACTED_FIELDS_AddressStateCode',
	EXTRACTED_FIELDS_ADDRESS_STREET_TYPE_ABBREVIATION = 'EXTRACTED_FIELDS_AddressStreetTypeAbbreviation',
	EXTRACTED_FIELDS_ADDRESS_UNIT_TYPE = 'EXTRACTED_FIELDS_AddressUnitType',
	EXTRACTED_FIELDS_ADDRESS_DELIVERY_POINT_ID = 'EXTRACTED_FIELDS_AddressDeliveryPointIdentifier',
	EXTRACTED_FIELDS_AGE_CATEGORY = 'EXTRACTED_FIELDS_AgeCategory',
	EXTRACTED_FIELDS_CHILDREN_COUNT = 'EXTRACTED_FIELDS_ChildernCount',
	EXTRACTED_FIELDS_ENTRY_MODE = 'EXTRACTED_FIELDS_EntryMode',
	EXTRACTED_FIELDS_VAF_NUM = 'EXTRACTED_FIELDS_VAFNumber',
	EXTRACTED_FIELDS_ADDRESS_LINE_5 = 'EXTRACTED_FIELDS_AddressLine5',
	EXTRACTED_FIELDS_RFID_PORTRAIT_PHOTO = 'EXTRACTED_FIELDS_RFIDPortraitPhoto',
	EXTRACTED_FIELDS_REF_ADDRESS_LINE_5 = 'EXTRACTED_FIELDS_RefAddressLine5',
	EXTRACTED_FIELDS_REF_ADDRESS_STATE_CODE = 'EXTRACTED_FIELDS_RefAddressStateCode',
	EXTRACTED_FIELDS_REF_ADDRESS_STREET_TYPE = 'EXTRACTED_FIELDS_RefAddressStreetType',
	EXTRACTED_FIELDS_REF_ADDRESS_STREET_TYPE_ABBREVIATION = 'EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation',
	EXTRACTED_FIELDS_REF_ADDRESS_STREET_SUFFIX = 'EXTRACTED_FIELDS_RefAddressStreetSuffix',
	EXTRACTED_FIELDS_REF_ADDRESS_UNIT_NUM = 'EXTRACTED_FIELDS_RefAddressUnitNumber',
	EXTRACTED_FIELDS_REF_ADDRESS_UNIT_TYPE = 'EXTRACTED_FIELDS_RefAddressUnitType',
	EXTRACTED_FIELDS_REF_ADDRESS_POST_CODE_TYPE = 'EXTRACTED_FIELDS_RefAddressPostcodeType',
	EXTRACTED_FIELDS_REF_ADDRESS_DELIVERY_POINT_ID = 'EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier',
	EXTRACTED_FIELDS_REF_ADDRESS_PO_BOX_NUM = 'EXTRACTED_FIELDS_RefAddressPOBoxNumber',
	EXTRACTED_FIELDS_REF_ADDRESS_DEPENDENT_LOCALITY = 'EXTRACTED_FIELDS_RefAddressDependentLocality',
	EXTRACTED_FIELDS_REF_ADDRESS_DOUBLE_DEPENDENT_LOCALITY = 'EXTRACTED_FIELDS_RefAddressDoubleDependentLocality',
	EXTRACTED_FIELDS_REF_ADDRESS_THOROUGHFARE = 'EXTRACTED_FIELDS_RefAddressThoroughfare',
	EXTRACTED_FIELDS_REF_ADDRESS_THOROUGHFARE_DESC = 'EXTRACTED_FIELDS_RefAddressThoroughfareDesc',
	EXTRACTED_FIELDS_REF_ADDRESS_DEPENDENT_THOROUGHFARE = 'EXTRACTED_FIELDS_RefAddressDependentThoroughfare',
	EXTRACTED_FIELDS_REF_ADDRESS_DEPENDENT_THOROUGHFARE_DESC = 'EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc',
	EXTRACTED_FIELDS_REF_ADDRESS_SUB_BUILDING_NUM = 'EXTRACTED_FIELDS_RefAddressSubBuildingNumber',
	EXTRACTED_FIELDS_ADDRESS_SUB_BUILDING_NUM = 'EXTRACTED_FIELDS_AddressSubBuildingNumber',
	EXTRACTED_FIELDS_ADDRESS_SUB_BUILDING_NAME = 'EXTRACTED_FIELDS_AddressSubBuildingName',
	EXTRACTED_FIELDS_ADDRESS_POST_CODE_TYPE = 'EXTRACTED_FIELDS_AddressPostCodeType',
	EXTRACTED_FIELDS_ISSUING_AUTHORITY_TYPE = 'EXTRACTED_FIELDS_IssuingAuthorityType',
	EXTRACTED_FIELDS_SIGNATURE = 'EXTRACTED_FIELDS_Signature',
	EXTRACTED_FIELDS_HOLOGRAM = 'EXTRACTED_FIELDS_Hologram',
	EXTRACTED_FIELDS_CARD_NUMBER = 'EXTRACTED_FIELDS_CardNumber',
	EXTRACTED_FIELDS_MIDDLE_NAME_INITIAL = 'EXTRACTED_FIELDS_MiddleNameInitial',
	EXTRACTED_FIELDS_PERMIT_NUM = 'EXTRACTED_FIELDS_PermitNumber',
	EXTRACTED_FIELDS_REFERENCE_NUM = 'EXTRACTED_FIELDS_ReferenceNumber',
	EXTRACTED_FIELDS_CUSTOMER_NUM = 'EXTRACTED_FIELDS_CustomerNumber',
	EXTRACTED_FIELDS_BOS_NUM = 'EXTRACTED_FIELDS_BOSNumber',
	EXTRACTED_FIELDS_STUDENT_ID = 'EXTRACTED_FIELDS_StudentID',
	EXTRACTED_FIELDS_MEMBERSHIP_NUMBER = 'EXTRACTED_FIELDS_MembershipNumber',
	EXTRACTED_FIELDS_LICENSE_TYPE = 'EXTRACTED_FIELDS_LicenseType',
	EXTRACTED_FIELDS_LICENSE_TYPE_2 = 'EXTRACTED_FIELDS_LicenseType2',
	EXTRACTED_FIELDS_LICENSE_TYPE_3 = 'EXTRACTED_FIELDS_LicenseType3',
	EXTRACTED_FIELDS_LICENSE_TYPE_4 = 'EXTRACTED_FIELDS_LicenseType4',
	EXTRACTED_FIELDS_DOCUMENT_TYPE_CODE = 'EXTRACTED_FIELDS_DocumentTypeCode',
	EXTRACTED_FIELDS_MRZ_DOCUMENT_NUMBER_CHECK_DIGIT = 'EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit',
	EXTRACTED_FIELDS_MRZ_BIRTH_DATE_CHECK_DIGIT = 'EXTRACTED_FIELDS_MRZBirthDateCheckDigit',
	EXTRACTED_FIELDS_MRZ_EXPORY_DATE_CHECK_DIGIT = 'EXTRACTED_FIELDS_MRZExpiryDateCheckDigit',
	EXTRACTED_FIELDS_MRZ_PERSONAL_NUMBER_CHECK_DIGIT = 'EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit',
	EXTRACTED_FIELDS_MRZ_COMPOSITE_CHECK_DIGIT = 'EXTRACTED_FIELDS_MRZCompositeCheckDigit',
	EXTRACTED_FIELDS_SECONDARY_PORTRAIT_PHOTO = 'EXTRACTED_FIELDS_SecondaryPortraitPhoto',
	EXTRACTED_FIELDS_FINGERPRINT = 'EXTRACTED_FIELDS_Fingerprint',
	EXTRACTED_FIELDS_VERSION_NUMBER = 'EXTRACTED_FIELDS_VersionNumber',
	EXTRACTED_FIELDS_CONDITIONS = 'EXTRACTED_FIELDS_Conditions',
	EXTRACTED_FIELDS_NICKNAME = 'EXTRACTED_FIELDS_NickName',
	EXTRACTED_FIELDS_ADDRESS_APARTMENT_NUMBER = 'EXTRACTED_FIELDS_AddressApartmentNumber',
	EXTRACTED_FIELDS_ADDRESS_FLOOR_NUM = 'EXTRACTED_FIELDS_AddressFloorNumber',
	EXTRACTED_FIELDS_FIRST_NAME_LOCAL = 'EXTRACTED_FIELDS_FirstNameLocal',
	EXTRACTED_FIELDS_LAST_NAME_LOCAL = 'EXTRACTED_FIELDS_LastNameLocal',
	EXTRACTED_FIELDS_FULL_NAME_LOCAL = 'EXTRACTED_FIELDS_FullNameLocal',
	EXTRACTED_FIELDS_BIRTH_PLACE_LOCAL = 'EXTRACTED_FIELDS_BirthPlaceLocal',
	EXTRACTED_FIELDS_ISSUING_AUTHORITY_LOCAL = 'EXTRACTED_FIELDS_IssuingAuthorityLocal',
	EXTRACTED_FIELDS_MOTHER_NAME_LOCAL = 'EXTRACTED_FIELDS_MotherNameLocal',
	EXTRACTED_FIELDS_FATHER_NAME_LOCAL = 'EXTRACTED_FIELDS_FatherNameLocal',
	EXTRACTED_FIELDS_ADDRESS_FULL_LOCAL = 'EXTRACTED_FIELDS_AddressFullLocal',
	EXTRACTED_FIELDS_MIDDLE_NAME_LOCAL = 'EXTRACTED_FIELDS_MiddleNameLocal',
	EXTRACTED_FIELDS_ADDRESS_LINE_1_LOCAL = 'EXTRACTED_FIELDS_AddressLine1Local',
	EXTRACTED_FIELDS_ADDRESS_LINE_2_LOCAL = 'EXTRACTED_FIELDS_AddressLine2Local',
	EXTRACTED_FIELDS_ADDRESS_LINE_3_LOCAL = 'EXTRACTED_FIELDS_AddressLine3Local',
	EXTRACTED_FIELDS_IND_REF_NUMBER_1 = 'EXTRACTED_FIELDS_IndRefNumber1',
	EXTRACTED_FIELDS_IND_REF_NUMBER_2 = 'EXTRACTED_FIELDS_IndRefNumber2',
	EXTRACTED_FIELDS_IND_REF_NUMBER_3 = 'EXTRACTED_FIELDS_IndRefNumber3',
	EXTRACTED_FIELDS_IND_REF_NUMBER_4 = 'EXTRACTED_FIELDS_IndRefNumber4',
	EXTRACTED_FIELDS_IND_REF_NUMBER_5 = 'EXTRACTED_FIELDS_IndRefNumber5',
	EXTRACTED_FIELDS_NAME_1 = 'EXTRACTED_FIELDS_Name1',
	EXTRACTED_FIELDS_NAME_2 = 'EXTRACTED_FIELDS_Name2',
	EXTRACTED_FIELDS_NAME_3 = 'EXTRACTED_FIELDS_Name3',
	EXTRACTED_FIELDS_NAME_4 = 'EXTRACTED_FIELDS_Name4',
	EXTRACTED_FIELDS_NAME_5 = 'EXTRACTED_FIELDS_Name5',
	EXTRACTED_FIELDS_RECIPIENT_NAME = 'EXTRACTED_FIELDS_RecipientName',
	EXTRACTED_FIELDS_RECIPIENT_NAME_1 = 'EXTRACTED_FIELDS_RecipientName1',
	EXTRACTED_FIELDS_RECIPIENT_NAME_2 = 'EXTRACTED_FIELDS_RecipientName2',
	EXTRACTED_FIELDS_RECIPIENT_NAME_3 = 'EXTRACTED_FIELDS_RecipientName3',
	EXTRACTED_FIELDS_RECIPIENT_NAME_4 = 'EXTRACTED_FIELDS_RecipientName4',
	EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL = 'EXTRACTED_FIELDS_RecipientAddressFull',
	EXTRACTED_FIELDS_IBAN = 'EXTRACTED_FIELDS_Iban',
	EXTRACTED_FIELDS_ACCOUNT_NUM = 'EXTRACTED_FIELDS_AccountNumber',
	EXTRACTED_FIELDS_ISSUER = 'EXTRACTED_FIELDS_Issuer',
	EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY = 'EXTRACTED_FIELDS_RecipientAddressCity',
	EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE = 'EXTRACTED_FIELDS_RecipientAddressPostCode',
	EXTRACTED_FIELDS_DAY = 'EXTRACTED_FIELDS_Day',
	EXTRACTED_FIELDS_MONTH = 'EXTRACTED_FIELDS_Month',
	EXTRACTED_FIELDS_YEAR = 'EXTRACTED_FIELDS_Year',
	EXTRACTED_FIELDS_OPTIONAL_VALUE_1 = 'EXTRACTED_FIELDS_OptionalValue1',
	EXTRACTED_FIELDS_OPTIONAL_VALUE_2 = 'EXTRACTED_FIELDS_OptionalValue2',
	EXTRACTED_FIELDS_OPTIONAL_VALUE_3 = 'EXTRACTED_FIELDS_OptionalValue3',
	EXTRACTED_FIELDS_OPTIONAL_VALUE_4 = 'EXTRACTED_FIELDS_OptionalValue4',
	EXTRACTED_FIELDS_ISSUING_STATE_NAME = 'EXTRACTED_FIELDS_IssuingStateName',
	EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID = 'EXTRACTED_FIELDS_Front Document Type ID',
	EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID = 'EXTRACTED_FIELDS_Back Document Type ID',
	HASNOCAMERA_TITLE = 'HASNOCAMERA_TITLE',
	HASNOCAMERA_DESCRIPTION = 'HASNOCAMERA_DESCRIPTION',
	USER_INPUT_FIRST_NAME = 'USER_INPUT_FIRST_NAME',
	USER_INPUT_MIDDLE_NAME = 'USER_INPUT_MIDDLE_NAME',
	USER_INPUT_LAST_NAME = 'USER_INPUT_LAST_NAME',
	USER_INPUT_DOB = 'USER_INPUT_DOB',
	USER_INPUT_HOUSE_NAME_NUMBER = 'USER_INPUT_HOUSE_NAME_NUMBER',
	USER_INPUT_STREET_NAME = 'USER_INPUT_STREET_NAME',
	USER_INPUT_TOWN = 'USER_INPUT_TOWN',
	USER_INPUT_POSTAL_CODE = 'USER_INPUT_POSTAL_CODE',
	USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE = 'USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE',
	USER_INPUT_STREET_NAME_EXAMPLE = 'USER_INPUT_STREET_NAME_EXAMPLE',
	USER_INPUT_TOWN_EXAMPLE = 'USER_INPUT_TOWN_EXAMPLE',
	USER_INPUT_POSTAL_CODE_EXAMPLE = 'USER_INPUT_POSTAL_CODE_EXAMPLE',
}
